const atualizarEquipamentos = (state, equipamentos) => {
    state.equipamentos = equipamentos;
}

const atualizarEquipamento = (state, equipamento) => {
    state.equipamento = equipamento;
}

const atualizarImplementos = (state, implementos) => {
    state.implementos = implementos;
}

const atualizarImplemento = (state, implemento) => {
    state.implemento = implemento;	
}

const atualizarAcessorios = (state, acessorios) => {
    state.acessorios = acessorios;
}

const atualizarAcessorio = (state, acessorio) => {
    state.acessorio = acessorio;
}

const atualizarProprietarios = (state, proprietarios) => {
    state.proprietarios = proprietarios;
}

const atualizarProprietario = (state, proprietario) => {
    state.proprietario = proprietario;
}

const atualizarPlanoEquipamentos = (state, equipamentosPlano) => {
    state.equipamentosPlano = equipamentosPlano;
}

const updateEquipamento = (state, equipamento) => {
    const item = state.equipamentos.find(item => item.id === equipamento.id);

    Object.assign(item, equipamento);
}

export default {
    atualizarEquipamentos,
    atualizarEquipamento,
	atualizarImplementos,
	atualizarImplemento,
	atualizarAcessorios,
	atualizarAcessorio,
	atualizarProprietarios,
	atualizarProprietario,
    atualizarPlanoEquipamentos,
    updateEquipamento
}